import { SelectedPhenomenonGroupId } from "atoms/Ltool/matrixAtoms";
import { Config } from "atoms/Ltool/newConfigAtoms";
import { DRIVE_MODE_IDS, PHENOMENON_IDS } from "utils/constsLtool";
import {
    DRIVE_MODE_IDS as HEV_DRIVE_MODE_IDS,
    PHENOMENON_IDS as HEV_PHENOMENON_IDS,
    PHENOMENON_IDS_BY_GROUP as HEV_PHENOMENON_IDS_BY_GROUP,
} from "utils/constsHev";

export const isInitial = (c: Config) =>
    Object.values(c).every(v => v === "");

export function removeDuplicates<T>(arr: T[]): T[] {
    return arr.filter((item, idx, self) =>
        self.indexOf(item) === idx
    );
};

export function buildConditionIds(
    phenomenonGroupId: SelectedPhenomenonGroupId | null = null,
    isHev = false,
): string[] {
    if (isHev) {
        // HEV は phenomenon の値域が条件グループ(gn/vib)単位で定義されるため、
        // BEV の文字列分割ではなく PHENOMENON_IDS_BY_GROUP を直接使う
        // （gn_pg_PS1 等は split では gn 判定できない）。
        const key = phenomenonGroupId as keyof typeof HEV_PHENOMENON_IDS_BY_GROUP;
        const phenHev = phenomenonGroupId && HEV_PHENOMENON_IDS_BY_GROUP[key]
            ? [...HEV_PHENOMENON_IDS_BY_GROUP[key]]
            : [...HEV_PHENOMENON_IDS];
        const drvHev = [...HEV_DRIVE_MODE_IDS];
        return phenHev.flatMap((p) => drvHev.map((d) => `${p}-${d}`));
    }
    const phen = PHENOMENON_IDS.filter((p) => {
        if (p === null) return false;
        if (phenomenonGroupId === null) return true;
        const parts = p.split("_");
        const groupHint = parts.length >= 2 ? parts[parts.length - 2] : null;
        return groupHint === phenomenonGroupId;
    }) as string[];
    const drv = DRIVE_MODE_IDS.filter(d => d !== null) as string[];
    return phen.flatMap(p =>
        drv.map(d => `${p}-${d}` as string)
    );
};
